export default "__VITE_PUBLIC_ASSET__58552fe7__"